import { get, isEqual, set, debounce, isEmpty, difference, compact } from 'lodash-es'

import { types as STORE_MODULES } from '@/js/plugins/store/store-modules'

// import APP_CONFIG_CONSTANTS from '@/js/helper/app-config-constants'
import APP_CONSTANTS from '@/js/plugins/store/modules/app/constants'
// import APP_ACTION_TYPES from '@/js/plugins/store/modules/app/action-types'
// import APP_GETTER_TYPES from '@/js/plugins/store/modules/app/getter-types'
import SEARCH_GETTER_TYPES from '@/js/plugins/store/modules/search/getter-types'
import SEARCH_CONSTANTS from '@/js/plugins/store/modules/search/constants.js'
import FILTER_CONSTANTS from '@/js/helper/filter-constants.js'

import {
  TYPES as AIMEOS_ACTION_TYPES,
  AIMEOS_GETTER_TYPES,
} from '@/js/plugins/store/modules/aimeos/actions/std-imports'

const APP = STORE_MODULES.APP
const AIMEOS = STORE_MODULES.AIMEOS
const SEARCH = STORE_MODULES.SEARCH

let firstDebounce = true // Use longer debounce for the first search request debouncedTriggerSearchLong

export default store => {
  const triggerSearch = async (immediate = false) => {
    if (firstDebounce) {
      // console.log('set firstDebounce to false')
      firstDebounce = false
    }

    const searchImmediate = get(store.state, `${APP}.${APP_CONSTANTS.SEARCH_IMMEDIATE}`, false)

    if (!immediate && !searchImmediate) {
      return
    }

    const page = get(store.state, `${SEARCH}.${SEARCH_CONSTANTS.TYPE.SEARCH_PAGE}`, 1)
    // store.dispatch(`${APP}/${APP_ACTION_TYPES.SHOW_SEARCH_DIALOG}`)
    // console.log('dispatch PRODUCT_SEARCH')

    // DCWSUPPORTDS-1950:
    // We need a searchInProgress Promise to check for dispatched,
    // but not yet started search requests
    // to avoid starting multiple request which could resolve out of order
    const searchInProgress = get(store.state, `${SEARCH}.${SEARCH_CONSTANTS.SEARCH_REQUEST}`)
    // console.log({
    //   searchInProgress,
    //   search: store.getters[`${STORE_MODULES.AIMEOS}/${AIMEOS_GETTER_TYPES.SEARCH_PENDING}`],
    // })
    if (
      searchInProgress &&
      !store.getters[`${STORE_MODULES.AIMEOS}/${AIMEOS_GETTER_TYPES.SEARCH_PENDING}`]
    ) {
      // console.log('searchInProgress: wait')
      await searchInProgress
      // console.log('searchInProgress: continue')
    }

    set(
      store.state,
      `${SEARCH}.${SEARCH_CONSTANTS.SEARCH_REQUEST}`,
      new Promise(resolve => {
        store
          .dispatch(`${AIMEOS}/${AIMEOS_ACTION_TYPES.PRODUCT_SEARCH}`, {
            // searchText,
            searchParams: store.getters[`${SEARCH}/${SEARCH_GETTER_TYPES.SEARCH_PARAMS}`],
            productType: store.getters[`${SEARCH}/${SEARCH_GETTER_TYPES.SEARCH_PRODUCT_TYPE}`],
            page,
          })
          .finally(result => {
            // console.log('searchInProgress: end')
            resolve(result)
          })
      }),
    )
  }
  const debouncedTriggerSearch = debounce(triggerSearch, 30)
  const debouncedTriggerSearchLong = debounce(triggerSearch, 1000)

  // store.watch(
  //   (state, getters) => getters[`${APP}/${APP_GETTER_TYPES.SEARCH_IMMEDIATE}`],
  //   triggerSearch,
  // )
  store.watch(
    (state, getters) => getters[`${SEARCH}/${SEARCH_GETTER_TYPES.SEARCH_PARAMS}`],
    (newValue, oldValue) => {
      // console.log('store.watch SEARCH_PARAMS')
      // console.log(newValue, oldValue)
      const newHas = compact(Object.entries(newValue).map(([k, v]) => JSON.stringify({ [k]: v })))
      const oldHas = compact(Object.entries(oldValue).map(([k, v]) => JSON.stringify({ [k]: v })))
      const diff = oldHas.length === newHas.length && isEmpty(difference(oldHas, newHas))
      // console.log({ newHas }, { oldHas })
      // console.log({ diff })

      const bothAreDefault =
        isEqual(FILTER_CONSTANTS.DEFAULTS, newValue) && isEqual(FILTER_CONSTANTS.DEFAULTS, oldValue)

      const productsFirstLoaded =
        !firstDebounce ||
        !isEmpty(store.getters[`${STORE_MODULES.AIMEOS}/${AIMEOS_GETTER_TYPES.PRODUCTS_DATA}`])

      // const searchSelection = get(store.state, `${APP}.${APP_CONSTANTS.SEARCH_SELECTION}`)

      const shouldCancel =
        (productsFirstLoaded && bothAreDefault) || (productsFirstLoaded && !bothAreDefault && diff)

      // console.log({ firstDebounce })
      // console.log({ productsFirstLoaded })
      // console.log({ shouldCancel })
      if (shouldCancel) {
        return
      }

      // if (
      //   isEqual(FILTER_CONSTANTS.DEFAULTS, newValue) &&
      //   isEqual(FILTER_CONSTANTS.DEFAULTS, oldValue)
      // ) {
      //   return
      // }

      const immediateSearch =
        get(oldValue, FILTER_CONSTANTS.TYPE.SEARCH_TEXT) !== '' &&
        get(newValue, FILTER_CONSTANTS.TYPE.SEARCH_TEXT) !== ''
      // triggerSearch(immediateSearch)
      if (firstDebounce) {
        debouncedTriggerSearchLong(immediateSearch)
      } else {
        debouncedTriggerSearch(immediateSearch)
      }
      // if search term is deleted do not trigger search when not on listpage
    },
    {
      deep: true,
    },
  )
}
